import {makeStyles} from '@material-ui/core/styles'

const theme = () => {
  const styles = makeStyles(theme => ({
    wrapper: {
      padding: "20px",
      border: "1px solid orange",
      borderRadius: '5px',
      backgroundColor: '#f9e6c3',
      margin: "20px",
      color: "#996d19"
    },
  }))
  return styles();
};

export default theme;